import type { Community } from 'types'
import store from './store'

export const communities = store<Community[]>([])
